import { connect } from 'react-redux';

import HeaderStepsIcons from '../../components/Templates/components/HeaderSteps/HeaderSteps';

const mapStateToProps = ({ app }) => ({
  asPath: app.getIn(['asPath']),
  featureFlags: app.getIn(['featureFlags']),
});

export default connect(mapStateToProps)(HeaderStepsIcons);
